import { Text, Stack, Center, Box, Anchor } from "@mantine/core";
import { Logo } from "../shared/components/Logo";
import { Link } from "wouter";
import { getLinkToConsole } from "../shared/links";
import { useAuth } from "../authentication/AuthProvider";

const ErrorPage = () => {
  const authContext = useAuth();
  return (
    <Center style={{ height: "100vh" }}>
      <Stack align="center" justify="center" gap="sm">
        <Text>Oops!</Text>
        <Box w={100}>
          <Logo style={{ transform: "rotate(180deg)" }} />
        </Box>
        <Text>{history.state}</Text>
        <Text size="lg">Sorry, we didn't know where to take you!</Text>
        {(authContext?.user ?? undefined) && (
          <Text size="lg">You are logged in as {authContext?.user?.email}</Text>
        )}
        <Link to={getLinkToConsole()} style={{ textDecoration: "none" }}>
          <Anchor component="span" underline="hover">
            Click here to go back to the app
          </Anchor>
        </Link>
      </Stack>
    </Center>
  );
};

export default ErrorPage;
